import {Component, OnInit} from '@angular/core';
import {BehaviorSubject} from '@node_modules/rxjs';
import {MembersInterface} from '@interfaces/members.interface';
import {ProgramService} from '@services/program/program.service';
import {StopSpinner} from '@store/spinner/actions';
import {ConfirmModalComponent} from '@components/confirm-modal/confirm-modal.component';
import {Store } from '@ngrx/store';
import * as SpinnerReducer from '@store/spinner/reducers';

@Component({
    selector: 'app-student-add',
    templateUrl: './student-add.component.html',
    styleUrls: ['./student-add.component.scss']
})
export class StudentAddComponent implements OnInit {
    static modalRef: any;
    static programId: number;
    static students: any;
    peopleDirectSearch: BehaviorSubject<string> = new BehaviorSubject('all');
    searchResults: BehaviorSubject<MembersInterface[]> = new BehaviorSubject(null);
    currentDirection = 'all';
    startSearching = false;
    users = [];
    selectedPersons = [];
    loading = false;

    constructor(
        private programService: ProgramService,
        private store: Store<SpinnerReducer.SpinnerState>,
    ) {
    }

    ngOnInit() {
    }

    setSearchResults(results: { result: Array<MembersInterface>, query: string }) {
        if ((results.query && results.query.length === 0 && this.currentDirection !== 'all') ||
            results.result && results.result.length > 0 || this.startSearching === false) {
            this.searchResults.next(results.result);
        } else {
            this.searchResults.next([]);
        }
    }

    selectedPerson(value) {
        for (let i = 0; i < this.selectedPersons.length; i++) {
            if (this.selectedPersons[i].id === value.id) {
                return;
            }
        }
        value.selected = 0;
        StudentAddComponent.students.map(student => {
            if (student.id === value.id) {
                value.selected = 1;
            }
        });
        this.selectedPersons.push(value);
    }

    addToProgram() {
        this.users.map(user => {
            const body = {
                user_id: user,
                program_id: StudentAddComponent.programId
            };
            this.loading = true;
            this.programService.addUser(body).subscribe(
                resp => {
                    // this.store.dispatch(new StopSpinner());
                    this.loading = false;

                    this.close();
                }
            );
        });
    }

    onChange(event, id) {
        if (event.checked) {
            this.users.push(id);
        } else {
            const index = this.users.indexOf(id);
            this.users.splice(index, 1);
        }
    }

    close() {
        StudentAddComponent.modalRef.close();
    }
}
